/**
 * /alerts/webhooks/new: add a webhook, then its signing secret, shown once. The API keeps only a sealed copy, so this
 * is the one chance to take it. Back to Alerts after "I've saved it".
 */
import { useState } from 'react'
import type { WebhookCreated } from '../../domain/schemas'
import { Card, Screen, Text, useNav } from '../../ui'
import { AddWebhookForm } from '../components/AddWebhookForm'
import { SecretOnce } from '../components/SecretOnce'

export function NewWebhookPage() {
  const { navigate } = useNav()
  const [created, setCreated] = useState<WebhookCreated | null>(null)
  const back = () => navigate('/alerts')
  return (
    <Screen
      title="Add webhook"
      crumb={{ label: 'Alerts', to: '/alerts' }}
      description="Each alert, its reminders and its clearing go to every webhook that covers it, signed with that webhook's secret. Failed sends retry for about four hours."
    >
      <Card title={created ? 'Its signing secret' : 'Where alerts go'}>
        {created ? (
          <SecretOnce
            message={
              <>
                <Text weight="head">{`Added ${created.webhook.description ?? created.webhook.url}.`}</Text> Copy its signing secret now. It won't be shown again;
                the receiver checks <Text mono>X-Cpg-Signature</Text> with it.
              </>
            }
            secret={created.secret}
            onDone={back}
          />
        ) : (
          <AddWebhookForm onCancel={back} onCreated={setCreated} />
        )}
      </Card>
    </Screen>
  )
}
